import { useLazyQuery, gql } from '@apollo/client';

const useGetAllTags = (onSuccess = () => {}, onError = () => {}) => {
  return useLazyQuery(
    gql`
      query allTags {
        allTags {
          docs {
            id
            name
            isActive
            type
            backgroundColor
            textColor
          }
        }
      }
    `,
    {
      fetchPolicy: 'cache-first',
      nextFetchPolicy: 'cache-first',
      notifyOnNetworkStatusChange: false,
      onCompleted: (res) => {
        onSuccess(res.allTags.docs)
      },
      onError
    }
  )
}


export default useGetAllTags
